export { default } from './card.view';
